<template>
    <div class="ns-sales-forecast">
        <div class="font-semibold text-base cursor-pointer flex items-center mb-3" style="font-size: 14px; width: fit-content;"
            @click="goBackTo()"
        >
        <img src="../../assets/icons/Back Arrow.png" alt="back" width="27px" class="mr-1">
            Back
        </div>

        <div class="ns-card px-6 py-5 mb-4">
            <div class="flex items-center justify-between mb-2 mt-1">
                <p class="text-lg font-bold">Sales Forecast by Location - 
                    <span class="capitalize">{{ storeName }}</span>
                    <span v-if="forecast_last_update_date && forecast_last_update_date.last_updated" class="text-base font-normal ml-8" style="font-size: 13px;">Last updated on {{ moment(forecast_last_update_date.last_updated, 'YYYY-MM-DD').format('Do MMM YY') }} </span>
                </p>
                <p class="text-sm font-semibold">
                    Today: {{ todayDate }}
                </p>
            </div>
            <!-- Actin header -->
            <div v-if="selected_view === 'week'" class="ns-sf--action-header">
                <el-row :gutter="20">
                    <el-col :sm="24" :md="4" :lg="4">
                        <p class="ns-label">Store</p>
                        <el-select v-model="selected_local_store" placeholder="Select store" filterable style="width: 100%" @change="handleOutletChange($event)">
                            <el-option v-for="outlet in outlets" :key="outlet.id" :label="outlet.name" :value="outlet.id"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :sm="24" :md="6" :lg="6">
                        <p class="ns-label">{{selected_view === 'day' || selected_view === 'week' ? 'Week' : 'Date'}}</p>
                        <el-date-picker v-model="selected_local_date" :type="selected_view === 'day' || selected_view === 'week' ? 'week' : 'date'" :picker-options="pickerOpt" :format="customDateFormat" placeholder="Select week" style="width: 100%;" @change="handleDateChange($event)"></el-date-picker>
                    </el-col>
                    <el-col :sm="24" :md="4" :lg="4">
                        <p class="ns-label">View</p>
                        <el-select v-model="selected_basic" placeholder="Select view" @change="handleViewChange(selected_basic);">
                            <el-option label="Sales" value="sales"></el-option>
                            <el-option label="Labour Hour" value="lab_hrs"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :sm="24" :md="4" :lg="4">
                        <p class="ns-label">Order Type</p>
                        <el-select v-model="selected_ot" :disabled="selected_basic === 'lab_hrs'" placeholder="Select Order Type" @change="handleOTChange(selected_ot)">
                            <el-option v-for="item in order_type_list" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
            <div v-if="selected_view !== 'week'" class="ns-sf--action-header">
                <el-row :gutter="20">
                    <el-col v-if="!checkCompany.is_bt" :sm="24" :md="3" :lg="3">
                        <div class="flex items-center">
                            <p :class="payload.view === 'day' && 'text-amplitude'" class="ns-sf--head-sel" @click="switchToView('day')">Week</p>
                            <p class="ns-sf--head-sel mx-2">|</p>
                            <p :class="payload.view === 'hour' && 'text-amplitude'" class="ns-sf--head-sel" @click="switchToView('hour')">Day</p>
                        </div>
                    </el-col>
                    <el-col :sm="24" :md="4" :lg="4">
                        <p class="ns-label">Store</p>
                        <el-select v-model="selected_local_store" placeholder="Select store" filterable style="width: 100%" @change="handleOutletChange($event)">
                            <el-option v-for="outlet in outlets" :key="outlet.id" :label="outlet.name" :value="outlet.id"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :sm="24" :md="selected_view === 'hour' ? 5 : 6" :lg="selected_view === 'hour' ? 5 : 6">
                        <p class="ns-label">{{selected_view === 'day' ? 'Week' : 'Date'}}</p>
                        <el-date-picker v-model="selected_local_date" :type="selected_view === 'day' ? 'week' : 'date'" :picker-options="pickerOpt" :format="customDateFormat" placeholder="Select week" style="width: 100%;" @change="handleDateChange($event)"></el-date-picker>
                    </el-col>
                    <el-col :sm="24" :md="4" :lg="3">
                        <p class="ns-label">View</p>
                        <el-select v-model="selected_basic" placeholder="Select view" @change="handleViewChange(selected_basic);">
                            <el-option label="Sales" value="sales"></el-option>
                            <el-option label="Labour Hour" value="lab_hrs"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :sm="24" :md="4" :lg="3">
                        <p class="ns-label">Order Type</p>
                        <el-select v-model="selected_ot" :disabled="selected_basic === 'lab_hrs'" placeholder="Select Order Type" @change="handleOTChange(selected_ot)">
                            <el-option v-for="item in order_type_list" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-col>
                    <template v-if="selected_view === 'hour' && selected_forecast_view === 'sales' && selected_order_type === 'all'">
                        <el-col :sm="24" :md="2" :lg="2">
                            <p class="ns-label">Weather</p>
                            <!-- Weather icon -->
                            <div v-if="weather_data.length" class="flex flex-col">
                                <div class="flex items-center  ">
                                    <img id="wicon" width="35px" :src="weatherIconClass(weather_data[0].weather_icon)" alt="Weather icon">
                                    <span class="capitalize text-amplitude">{{ weather_data[0].type }}</span> 
                                </div>
                                <p class="ml-3">{{ weather_data[0].temp_min + '°C / ' + weather_data[0].temp_max + '°C' }} </p>
                            </div>
                            <!-- Else show loading -->
                            <div v-else>
                                <el-skeleton :rows="3" />
                            </div>
                        </el-col>
                        <el-col v-if="event_data.length" :sm="24" :md="4" :lg="4">
                            <!-- Event list -->
                            <div>
                                <p class="ns-label">Events</p>
                                <div v-for="(event, index) in event_data.slice(0, 2)" :key="event.id + index" >
                                    <p class="capitalize text-amplitude text-sm ns-sf--event-title">
                                        {{ event.name }} - {{ moment(event.start_time, 'HH:mm:ss').format("hh:mm A") }} To {{ moment(event.end_time, 'HH:mm:ss').format("hh:mm A") }}
                                    </p>
                                </div>
                                <template v-if="event_data.length > 2">
                                    <el-popover placement="top-start" trigger="hover" width="450px">
                                        <el-tag slot="reference" class="hover-text text-sm text-amplitude" size="mini" type="warning" style="margin-bottom: 2px">+ {{ event_data.length - 2 }}</el-tag>
                                        <el-table :data="event_data.slice(2)"  height="250">
                                            <el-table-column label="Event Name" width="350px">
                                                <template slot-scope="{ row }">
                                                    {{ row.name }}
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Time" width="180px">
                                                <template slot-scope="{ row }">
                                                    {{ moment(row.start_time, 'HH:mm:ss').format("hh:mm A") }} To {{ moment(row.end_time, 'HH:mm:ss').format("hh:mm A") }}
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-popover>
                                </template>
                            </div>
                        </el-col>

                        <el-col :sm="24" :md="2" :lg="2">
                            <!-- Event list -->
                            <div>
                                <p class="ns-label">Status</p>
                                <el-tag v-if="is_forecast_approved" type="success" class="ns-tag mt-5 cursor-pointer" @click="approveForecast(formattedForecastDate)">Approved</el-tag>
                                <el-tag v-else type="warning" class="ns-tag mt-5 cursor-pointer" @click="approveForecast(formattedForecastDate)">Pending</el-tag>
                           </div>
                           <!-- <p v-else class="mt-6">No events</p> -->
                        </el-col>
                    </template>
                </el-row>
            </div>
        </div>
        <div class="ns-card px-6 py-12"> 
            <!-- Location Sales Forecast -->
            <SalesForecastLocation v-if="selected_view === 'week'" />
            <sales-forecast-view v-else/>
        </div>


         <!-- Dialog -->
         <div v-if="approve_forecast_dialog">
            <el-dialog v-loading="forecast_popup_loading"
                :visible.sync="approve_forecast_dialog" fullscreen custom-class="ns-dialog" :show-close="false">
                <div class="font-semibold text-base cursor-pointer flex items-center mb-5 ml-4" style="font-size: 14px; width: fit-content;"
                    @click="approve_forecast_dialog = false"
                >
                <img src="../../assets/icons/Back Arrow.png" alt="back" width="27px" class="mr-1">
                    Back
                </div>
                <div class="flex items-center justify-between mb-2 ml-5">
                    <p class="text-lg font-bold capitalize text-black"> {{ storeName }} -
                        <span class="capitalize">{{ set_selected_approve_date }}</span>
                        <span v-if="forecast_last_update_date && forecast_last_update_date.last_updated" class="text-base font-normal ml-8" style="font-size: 13px;">Last updated on {{ moment(forecast_last_update_date.last_updated, 'YYYY-MM-DD').format('Do MMM YY') }} </span>
                    </p>
                </div>
                 <!-- Graph -->
                 <div class="flex items-center justify-end mt-8" style="margin-right: 9.5%">
                        <p :class="show_by === 'sales' && 'text-amplitude'" class="ns-sf--head-sel text-sm uppercase cursor-pointer font-semibold" @click="handleData('sales')">Sales</p>
                        <p class="ns-sf--head-sel mx-2">|</p>
                        <p :class="show_by === 'trx' && 'text-amplitude'" class="ns-sf--head-sel text-sm uppercase cursor-pointer font-semibold" @click="handleData('trx')">Transactions</p>
                    </div>
                 <DayForecastGraph class="mb-8" :is-data-loaded="forecast_popup_loaded" :graph-label="graph_label"  :graph-data="forecast_graph_data" />
                <ApproveForecast :store-name="storeName" :approve-dates-list="approve_dates_list" :selected-store="selected_store_id" :formatted-day="formattedDay"
                    :all-events="event_data" :event-categories="event_categories" :is-data-loaded="forecast_popup_loaded" :selected-date="set_selected_approve_date"
                    :forecast-data="forecast_approve_data" @updateAdjTrx="updateAdjTrx" @updateApproveDate="updateApproveDate" @closeAction="approve_forecast_dialog = false"/>
                <span slot="footer" class="dialog-footer">
                    <el-button class="ns-light-button" @click="approve_forecast_dialog = false">Cancel</el-button>
                    <el-button class="ns-button ns-sf--approve-btn" :style="is_forecast_approved ? 'cursor: not-allowed;' : 'cursor:pointer;'" @click="is_forecast_approved ? '' : callApproveForecast()">{{ is_forecast_approved ? 'Approved' : 'Approve'}}</el-button>
                    <!-- <a @click="callUnApproveForecast">Undo</a> -->
                </span>
            </el-dialog>
        </div>
        <!-- Dialog -->
    </div>
</template>

<script>
import SalesForecastLocation from "../../components/UI/sections/SalesForecastLocation.vue";
import salesForecastMixin from "../../../mixins/salesForecastMixin.js";
import SalesForecastView from '../../components/UI/sections/SalesForecastView.vue';
import ApproveForecast from '../../components/UI/dialogs/ApproveForecast.vue';
import DayForecastGraph from '../../components/UI/graphs/DayForecastGraph.vue';
import moment from 'moment'
    export default {
        name: "SalesForecast",
        components: {
            SalesForecastLocation,
            SalesForecastView,
            ApproveForecast,
            DayForecastGraph
        },
        mixins: [salesForecastMixin],
        data() {
            return {
                moment
            }
        },
        computed: {

        },
        mounted() {
            this.selected_local_date = this.selected_forecast_date;
            this.selected_local_store = this.selected_outlet;
            this.getForecastStatus({outlet:this.selected_outlet});
            this.getOrderTypeList();
        },
        beforeDestroy() {

        },
        methods: {
            
        }
    }
</script>

<style lang="scss" scoped>
.ns-sales-forecast{
    .ns-tag{
        padding-left: 25px !important;
        padding-right: 25px !important;
    }
}
    .ns-card {
        box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
        border-radius: 2px !important;
    }
    .ns-sf--action-header {
        .el-row{
            margin-top: 25px;
        //   for desktop
            @media (min-width: 768px){
                display: flex;
                align-items: center;
            }
            .el-col{
                // For mobile
                @media (max-width: 767px){
                    margin-bottom: 20px;
                    .el-select{
                        width: 100%;
                    }
                }
            }
        }
        p.ns-sf--head-sel{
            font-size: 15px;
            text-transform: uppercase;
            font-weight: 600;
            cursor: pointer;
        }
    }
    .ns-sf--event-title{
        font-size: 13px;
        margin-bottom: 5px !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    // if screen size is less than 1300px
    @media (max-width: 1300px){
        .ns-sf--action-header{
             font-size: 12px !important;
        }
    }
</style>

<style>

.ns-dialog .el-dialog__header {
    padding: 0px;
    /* background: #fdfdfd;
    color: #1c1b1b;
    border-radius: 8px; */
}

.ns-dialog.el-dialog {
    border-radius: 8px;
}

.ns-dialog .el-dialog__title {
    text-transform: capitalize;
    color: #1c1b1b;
    font-weight: 700;
}

.ns-dialog .el-dialog__footer {
    /* position: fixed; */
    bottom: 0;
    width: 100%;
    padding: 15px 35px;
    background: #fff;
    border-radius: 8px;
}
.ns-dialog .el-dialog__headerbtn .el-dialog__close {
    color: #000000;
    font-weight: 600;
    font-size: 25px;
}
.ns-sf--approve-btn{
    background: #D26300;
    color: #fff;
}
.el-table  th.el-table__cell {
    background: #f8f8f8 !important;
}
</style>